var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuaraAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6210_24951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7384 18.701C11.9074 17.066 10.9334 15.414 9.03037 15.414C8.66837 15.414 8.30337 15.475 7.97137 15.623L7.32537 14.334C8.11137 13.656 9.38337 13.12 11.0184 13.12C13.5624 13.12 14.8694 14.349 15.9064 15.912C16.5194 14.577 16.8104 12.772 16.8104 10.537C16.8104 4.955 15.0664 2.09 10.9884 2.09C6.97037 2.09 5.23137 4.955 5.23137 10.537C5.23137 16.09 6.97037 18.926 10.9884 18.926C11.6284 18.926 12.2084 18.857 12.7384 18.701ZM13.7344 20.648C12.8534 20.885 11.9174 21.014 10.9914 21.014C5.63937 21.014 0.401367 16.745 0.401367 10.536C0.402367 4.271 5.63937 0 10.9914 0C16.4324 0 21.6194 4.238 21.6194 10.537C21.6194 14.041 19.9844 16.888 17.6094 18.728C18.3734 19.876 19.1524 20.642 20.2614 20.642C21.4604 20.642 21.9414 19.727 22.0314 18.993H23.5884C23.6804 19.967 23.1864 24 18.8224 24C16.1704 24 14.7754 22.472 13.7264 20.672L13.7344 20.648Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6210_24951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuaraAdmin);
export default __webpack_public_path__ + "static/media/quara-admin.1da36f2d61f6cc9dd70a590e7b8c1a19.svg";
export { ForwardRef as ReactComponent };